import React, { useEffect, useState } from 'react';
import { Call } from '@saleshandy/icons';

import Modal from '../../../../../../../shared/design-system/components/atoms/modal';
import { AddPhoneNumberPayload } from '../../../../../types/do-not-call-list';

import CountryCodePhoneInputPicker from '../../../../../../../shared/components/country-code-phone-input-picker/country-code-phone-input-picker';
import { DialerCall } from '../../../../../../../shared/svg/dialer-call';

type IProps = {
  show: boolean;
  isLoading: boolean;
  dncListId: string;
  onClose: VoidFunction;
  onSubmit: (payload: AddPhoneNumberPayload) => void;
};

const AddPhoneNumber: React.FC<IProps> = ({
  show,
  isLoading,
  dncListId,
  onClose,
  onSubmit,
}) => {
  const [phone, setPhone] = useState('');
  const [countryCode, setCountryCode] = useState('+1');
  const [countryIso, setCountryIso] = useState('US');
  const [rawNumber, setRawNumber] = useState('');

  const isSubmitDisabled = isLoading || !rawNumber || rawNumber.length < 4;

  const handleSubmit = () => {
    if (isSubmitDisabled) return;
    onSubmit({
      dncListId,
      countryCode,
      phoneNumber: rawNumber,
      updateOutcome: false,
    });
  };

  const handleClose = () => {
    setPhone('');
    setCountryCode('+1');
    setCountryIso('US');
    setRawNumber('');
    onClose();
  };

  useEffect(() => {
    if (!show) {
      setPhone('');
      setCountryCode('+1');
      setCountryIso('US');
      setRawNumber('');
    }
  }, [show]);

  return (
    <Modal
      show={show}
      onClose={handleClose}
      onSubmit={handleSubmit}
      titleContent={
        <div className="d-flex align-items-center add-phone-number-modal-title-content">
          <DialerCall
            width={20}
            height={20}
            className="add-phone-number-modal-icon"
          />
          <span>Add Phone Number</span>
        </div>
      }
      showCloseIcon
      submitButtonText="Save"
      cancelButtonText="Cancel"
      isSubmitLoading={isLoading}
      isSubmitDisabled={isSubmitDisabled}
      backdrop="static"
      extraModalProps={{ enforceFocus: false }}
      className="add-phone-number-modal"
    >
      <div className="add-phone-number-modal--body">
        <span className="add-phone-number-label">Phone Number</span>
        <CountryCodePhoneInputPicker
          phoneNumber={phone}
          onPhoneNumberChange={(nationalDigits) => {
            // Picker input is national number only (digits), not E.164 / +country.
            setPhone(nationalDigits);
            setRawNumber(nationalDigits);
          }}
          defaultCountryISOCode={countryIso}
          onCountryChange={(country) => {
            if (!country?.code) return;
            setCountryCode(country.code);
            setCountryIso(country.iso);
          }}
          containerClassName="add-phone-number-input"
        />
      </div>
    </Modal>
  );
};

export default AddPhoneNumber;
